import { type Theme } from "@mui/material/styles";
import { merge } from "lodash";

import Autocomplete from "./Autocomplete";
import Checkbox from "./Checkbox";
import Chip from "./Chip";
import DataGrid from "./DataGrid";
import Input from "./Input";
import Pickers from "./Pickers";
import Select from "./Select";
import TextField from "./TextField";

// ----------------------------------------------------------------------

export default function ComponentsOverrides(theme: Theme) {
  return merge(
    Input(theme),
    DataGrid(),
    Select(theme),
    Pickers(theme),
    Checkbox(theme),
    Autocomplete(theme),
    Chip(theme),
    TextField()
  );
}
